"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToView = void 0;
/**
 * Maps a block to another view.
 *
 * @includeExample ./src/map-to-view.example.ts
 */
function mapToView(subject, view, targetView) {
    const hRatio = targetView.w / view.w;
    const vRatio = targetView.h / view.h;
    const x = (subject.x - view.x) * hRatio + targetView.x;
    const y = (subject.y - view.y) * vRatio + targetView.y;
    const w = subject.w * hRatio;
    const h = subject.h * vRatio;
    return { x, y, w, h };
}
exports.mapToView = mapToView;
